import { FC } from 'react';
import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import PackShopPage from '../../../pages/Cards/PackShopPage';
import PackShopMobile from '../../../pages/Mobile/Cards/PackShopMobile';

const PackShopResponsive: FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <PackShopMobile /> : <PackShopPage />;
};

export default PackShopResponsive;
